import { render } from "./objects-custom-grid-ro.vue?vue&type=template&id=1554c935"
import script from "./objects-custom-grid-ro.vue?vue&type=script&setup=true&lang=js"
export * from "./objects-custom-grid-ro.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/user-reference-books/objects-custom-grid-ro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1554c935"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1554c935', __exports__)) {
    api.reload('1554c935', __exports__)
  }
  
  module.hot.accept("./objects-custom-grid-ro.vue?vue&type=template&id=1554c935", () => {
    api.rerender('1554c935', render)
  })

}


export default __exports__